/** Alliance Campaigns / generic link brand tint */
export const SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR = '#299FE7';
export const SOCIAL_MEDIA_DEFAULT_CUSTOM_ICON_COLOR = '#FFFFFF';
export const SOCIAL_MEDIA_DEFAULT_CUSTOM_SHAPE_COLOR = '#000000';
export const SOCIAL_MEDIA_DEFAULT_BRAND_SHAPE_COLOR = '#FFFFFF';

/** Icon fills when Style = Brand colors (matches platform branding). */
export const SOCIAL_MEDIA_BRAND_ICON_COLORS: Record<string, string> = {
  FB: '#1877F2',
  IG: '#E4405F',
  LI: '#0A66C2',
  TW: '#000000',
  YT: '#FF0000',
  Other: SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR,
  AC: SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR,
};

export const SocialMediaColorStyle = {
  brandColors: 'brandColors',
  customColors: 'customColors',
} as const;

export type SocialMediaColorStyleId = (typeof SocialMediaColorStyle)[keyof typeof SocialMediaColorStyle];

export function resolveSocialMediaIconFillColor(params: {
  socialMedia: string;
  colorStyle?: unknown;
  iconColor?: unknown;
}): string {
  const styleKey = params.colorStyle;

  if (styleKey === undefined || styleKey === null || styleKey === '') {
    return String(params.iconColor ?? SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR);
  }

  if (String(styleKey) === SocialMediaColorStyle.customColors) {
    return String(params.iconColor ?? SOCIAL_MEDIA_DEFAULT_CUSTOM_ICON_COLOR);
  }

  const key = String(params.socialMedia ?? '').trim();
  return SOCIAL_MEDIA_BRAND_ICON_COLORS[key] ?? SOCIAL_MEDIA_DEFAULT_BRAND_ICON_COLOR;
}

export function resolveSocialMediaShapeBackgroundColor(params: {
  colorStyle?: unknown;
  shapeColor?: unknown;
  framed: boolean;
}): string | undefined {
  if (!params.framed) {
    return undefined;
  }

  const explicit = params.shapeColor;
  if (explicit !== undefined && explicit !== null && String(explicit).trim() !== '') {
    return String(explicit);
  }

  const styleKey = params.colorStyle;
  if (styleKey === undefined || styleKey === null || styleKey === '') {
    return undefined;
  }

  if (String(styleKey) === SocialMediaColorStyle.customColors) {
    return SOCIAL_MEDIA_DEFAULT_CUSTOM_SHAPE_COLOR;
  }

  return SOCIAL_MEDIA_DEFAULT_BRAND_SHAPE_COLOR;
}
